module.exports = __webpack_public_path__ + "static/media/ferrari__black-red.edbaaad6.jpg";